export const USER_ROLES = ['ADMIN', 'REPORTS', 'SURVEY'] as const;

export type UserRole = (typeof USER_ROLES)[number];

export const ROOT_ADMIN_USERNAME = 'superadmin';
export const MANAGEMENT_CENTER = 'Management';

export function isUserRole(value: unknown): value is UserRole {
  return typeof value === 'string' && USER_ROLES.includes(value as UserRole);
}
